import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import { number } from "prop-types";
import React, { useState } from "react";
import { BsWallet } from "react-icons/bs";
import { TransverseLoading } from "react-loadingg";
import IntlMessages from "../../util/IntlMessages";
import WalletDropdown from "./WalletDropdown/WalletDropdown";

const Wallet = () => {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);

  // const openInNewTab = (url) => {
  //   const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  //   if (newWindow) newWindow.opener = null;
  //   handleRequestClose();
  // };

  const handleRequestClose = () => {
    setOpen(false);
    setAmount("");
    setLoading(false);
  };

  const clickHandler = async () => {
    setLoading(true);
  };

  const handleSnackbar = () => {
    setOpenSnack(false);
    setError("");
  };

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  return (
    <div style={{ position: "relative", display: "none" }}>
      <div
        style={{
          direction: "rtl",
          borderRadius: 14,
          backgroundColor: "#ffd974",
          padding: 10,
          display: "flex",
          alignItems: "center",
          marginRight: 10,
          cursor: "pointer",
        }}
        onClick={handleOpenDropdown}
      >
        <span style={{ marginRight: 5, marginLeft: 5, color: "#1d1c22" }}>
          <BsWallet fontSize={"large"} style={{ color: "black" }} />
        </span>
      </div>
      {openDropdown && (
        <WalletDropdown
          setOpen={setOpen}
          handleOpenDropdown={handleOpenDropdown}
        />
      )}
      <Dialog open={open} onClose={handleRequestClose}>
        <div className="login-content text-center" style={{ maxWidth: "100%" }}>
          <div className="mb-4">
            <h2>
              <IntlMessages id="page.addBalance" />
            </h2>
          </div>

          <div className="login-form">
            <div className="form-group">
              <input
                style={{ direction: "ltr" }}
                defaultValue={number}
                type="number"
                placeholder="۱۰۰۰,۰۰۰"
                className="form-control form-control-lg"
                name="amount"
                value={amount}
                onChange={(event) => setAmount(event.target.value)}
              />
            </div>
            <div className="mt-4 mb-2">
              <button
                className="btn btn-primary jr-btn-rounded add-user-btn jr-btn-uptin"
                disabled={loading}
                color="primary"
                onClick={clickHandler}
              >
                {loading ? (
                  <TransverseLoading />
                ) : (
                  <IntlMessages id="page.paymentBalance" />
                )}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={openSnack}
        className="add-user-snackbar"
        onClose={handleSnackbar}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">{error}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={handleSnackbar}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </div>
  );
};

export default Wallet;
